import { quickOrderPageContainerStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderPageContainer";
import { css } from "styled-components";

quickOrderPageContainerStyles.firstGridItem = {
    ...quickOrderPageContainerStyles.firstGridItem,
    css: css`
        ${quickOrderPageContainerStyles.firstGridItem?.css}
        padding-bottom: 0;
    `,
};

quickOrderPageContainerStyles.leftColumnGridItem = {
    ...quickOrderPageContainerStyles.leftColumnGridItem,
    align: "middle",
};

quickOrderPageContainerStyles.rightColumnGridItem = {
    ...quickOrderPageContainerStyles.rightColumnGridItem,
    align: "middle",
};
